import 'view-design/dist/styles/iview.css';
import {
  Button,
  InputNumber,
  RadioGroup,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Radio,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  CheckboxGroup,
  Checkbox,
  Page,
  Message,
  DatePicker,
  Spin,
  Modal,
  BackTop,
  Alert,
  LoadingBar,
} from 'view-design';
const Ecomponents = {
  Button,
  InputNumber,
  RadioGroup,
  Radio,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  CheckboxGroup,
  Checkbox,
  Page,
  Message,
  DatePicker,
  Spin,
  Modal,
  BackTop,
  Alert,
  LoadingBar,
};
const iviewModule = {
  ...Ecomponents,
  iButton: Button,
  iInputNumber: InputNumber,
  iRadioGroup: RadioGroup,
  iForm: Form,
  iFormItem: FormItem,
  iIcon: Icon,
  iInput: Input,
  iSelect: Select,
  iOption: Option,
  iRadio: Radio,
  iBreadcrumb: Breadcrumb,
  iBreadcrumbItem: BreadcrumbItem,
  iCheckboxGroup: CheckboxGroup,
  iCheckbox: Checkbox,
  iPage: Page,
  iMessage: Message,
  iDatePicker: DatePicker,
  iSpin: Spin,
  iModal: Modal,
  iBackTop: BackTop,
  iAlert:Alert,
  iLoadingBar :LoadingBar,
};
export default iviewModule;



// WEBPACK FOOTER //
// ./src/plugins/iview.js